import { Grid, Paper, TableFooter, TablePagination } from "@material-ui/core";
import {
  createStyles, makeStyles,
  Theme
} from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import { Edit } from "@material-ui/icons";
import HourglassFullIcon from '@mui/icons-material/HourglassFull';
import Button from "@mui/material/Button";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory, useParams, useRouteMatch } from "react-router-dom";
import Api from "../../../../helpers/api";
import { StyledTableCell, StyledTableRow } from "../../containers/StyledTableCell";
import {
  getProjects,
  getProjectSampleAllData,
  UpdateDataFullFill,
} from "../../store/actions";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableContainer: {
      marginTop: "2rem",
      position: "sticky",
      top: "200px",
    },
  })
);

interface Props {
  getProjects: any;
  projects: any;
  getProjectSampleAllData: any;
  sampleAllData: any;
  subProjectId: any;
  UpdateDataFullFill: any;
  postDataFullFill: any;

}
const RegisterData: React.FC<Props> = ({
  getProjects,
  projects,
  getProjectSampleAllData,
  subProjectId,
  UpdateDataFullFill,
  postDataFullFill,

}) => {
  const classes = useStyles();
  const history = useHistory();
  const { url } = useRouteMatch();
  const [page, setPage] = useState(0);
  const [projectSamples, setProjectSamples] = useState<any[]>([]);
  const { id } = useParams<{ id: string }>();


  useEffect(() => {
    getProjects();
    getProjectSampleAllData();
  }, [getProjectSampleAllData, getProjects]);

  useEffect(() => {
    if (subProjectId) {
      Api.get("/genomics/project-samples", { subProject: subProjectId }).then((data: any) => {
        setProjectSamples(data?.results);
      });
    }
  }, [subProjectId])

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    if (newPage > page) {
      let url = projects.links && projects.links.next.split("?")[1];
      getProjects(`?${url}`);
    } else if (newPage < page) {
      let url = projects.links && projects.links.previous.split("?")[1];
      getProjects(`?${url}`);
    }
    setPage(newPage);
  };

  const handleDataFullfill = (id: any) => {
    dialogBox(id);
  };

  const dialogBox = (getId: any) => {
    let text = "Are You Sure You Want To Skip Library And Seuencing process?";
    if (window.confirm(text) === true) {
      text = "Yes";
      UpdateDataFullFill({ data: "" }, getId);
      setTimeout(() => {
        getProjects();
      }, 1000);
    } else {
      text = "No";
    }
  }
  return (
    <Grid container spacing={2} style={{ marginTop: 20 }}>
      <Grid container style={{ marginTop: 10 }}>
        <TableContainer
          className={classes.tableContainer}
          component={Paper}
          style={{ maxHeight: "480px" }}
        >
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <StyledTableRow>
                <StyledTableCell align="center">Project ID</StyledTableCell>
                <StyledTableCell align="center">Client Name</StyledTableCell>
                <StyledTableCell align="center">Institute Name</StyledTableCell>
                <StyledTableCell align="center">Dealer Name</StyledTableCell>
                <StyledTableCell align="center">SubProject Name</StyledTableCell>
                <StyledTableCell align="center">No Of Samples</StyledTableCell>
                <StyledTableCell align="center">Status</StyledTableCell>
                <StyledTableCell align="center">Action</StyledTableCell>
                <StyledTableCell align="center">Data FullFill</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {projects &&
                projects?.results &&
                projects?.results?.flatMap((project: any) => {
                  return project.subProjects.filter((subProject: any) => !subProjectId || subProject._id === subProjectId).map(
                    (subProject: any, index: number) => {
                      return (
                        <StyledTableRow key={subProject._id}>
                          <StyledTableCell align="center">
                            {project?.projectId}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {project?.scientist?.name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {project?.institute?.name}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {project?.dealer?.firmName}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {subProject?.title}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {subProject?.sampleCount}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            {subProject?.sampleRegistered === true ? "Register" : "Not Register"}
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <Button
                              color="primary"
                              variant="contained"
                            >
                              <Edit onClick={() => {
                                history.push(
                                  `${url}/${project?._id}/${subProject?._id}`
                                );
                              }} />
                            </Button>
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <Button
                              onClick={() => handleDataFullfill(project?._id)}
                              variant="contained"
                              disabled={subProject?.sampleRegistered === false || project?.phase === "Data Fulfilled" || project?.phase === "Bio Informatics" || project?.phase === "Delivered" || project.phase === "Closed"}
                              style={{
                                backgroundColor: "#6d1b7b",
                              }}
                            >
                              <HourglassFullIcon />
                            </Button>
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    }
                  );
                })}
            </TableBody>
            <TableFooter>
              <TablePagination
                rowsPerPageOptions={[]}
                colSpan={3}
                count={projects?.count || 0}
                rowsPerPage={projects?.page_size}
                page={page}
                onPageChange={handleChangePage}
              />
            </TableFooter>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
const mapStateToProps = (state: any) => ({
  projects: state.GenomicsLabReducer.projects,
  sampleAllData: state.GenomicsLabReducer.sampleAllData,
  postDataFullFill: state.GenomicsLabReducer.postDataFullFill,
});
export default connect(mapStateToProps, {
  getProjects,
  // getProjectSample,
  getProjectSampleAllData,
  UpdateDataFullFill,
})(RegisterData);
